export const projects = [
    {
        title: "HP Anyware for Windows 365",
        subtitle: "NodeJS + ExpressJS + MongoDB + React + Redis + Redux + Docker + Azure",
        description: "Developed in collaboration with Microsoft to enable seamless remote work and cloud PC management through HP's cloud-native platform.",
        image: "./img/hp_anyware.png",
        link: "https://reinvent.hp.com/Anyware-for-windows365",
        l1: "End-to-End API Development",
        l2: "Scalable Backend Services",
        l3: "Cloud Automation & Workload Orchestration",
        l4: "Integrated Logging & Monitoring Solutions",
        l5: "Collaborative Agile Development",
    },
    {
        title: "E-Commerce Platform",
        subtitle: "Java + Spring Boot + MySQL + React + JWT + Docker + AWS",
        description: "Built a feature-rich full-stack e-commerce platform with secure authentication, order management, and product catalog capabilities, ensuring a seamless shopping experience across devices.",
        image: "./img/e_commerce.png",
        link: "https://github.com/QI-D/ecommerce-frontend",
        l1: "Secure RESTful API Development",
        l2: "Responsive Frontend with State Management",
        l3: "Product Browsing, Cart Management, and Order Placing",
        l4: "Admin Panel for Easy Content Management",
        l5: "Responsive Design for Mobile and Desktop"
    },
    {
        title: "Mini Casino",
        subtitle: "Java + Spring Boot + MySQL + React + Redux + JWT + Docker",
        description: "A full-stack casino application that simulates various casino games. It allows players to register, authenticate, deposit funds, place bets, and check their game statistics and balance.",
        image: "./img/mini_casino.png",
        link: "https://github.com/QI-D/mini-casino-frontend",
        l1: "Player Authentication & Registration",
        l2: "Game Management",
        l3: "Deposit and Balance Management",
        l4: "Betting System with Game Outcomes",
        l5: "Dockerized Setup for Streamlined Deployment"
    },
    {
        title: "Inventory Management System",
        subtitle: "Python + Connexion + MySQL + React + Kafka + OpenAPI + Docker + AWS",
        description: "Web-based Inventory Management System. Tracks inventory availability at all points of your supply chain. ",
        image: "./img/inventory.png",
        link: "https://github.com/QI-D/Inventory_Management_System",
        l1: "Microservices Architecture",
        l2: "Event-driven Architecture",
        l3: "Inventory Intake & Tracking",
        l4: "Revenue Reporting & Analytics",
        l5: "Cloud-Native Deployment with AWS & Docker",
    },
    {
        title: "Smart Roster Scheduler",
        subtitle: "Python + Flask + jQuery + MySQL",
        description: "In partnership with Subject Matter Expertise from BC Women's Hospital, to simplify the process for shift assigments.",
        image: "./img/scheduler.jpg",
        link: "https://github.com/QI-D/SMART-roster",
        l1: "User Authentication & Authorization",
        l2: "Shift Assignment Automation",
        l3: "Conflict Detection & Alerts",
        l4: "Database Management",
        l5: "Test-Driven Development & Agile Methodology",
    },
    {
        title: "Social Reminder",
        subtitle: "NodeJS + ExpressJS + EJS + MongoDB",
        description: "Web-based Reminder App. Connect with your friends and see what they are up to.",
        image: "./img/reminder_app.jpg",
        link: "https://github.com/QI-D/Reminder-App-Project",
        l1: "MVC Architecture",
        l2: "User Authentication & Authorization",
        l3: "Friend System",
        l4: "Reminder Creation & Modification",
        l5: "Real-Time Updates",
    },
    // {
    //     title: "Snake Game",
    //     subtitle: "Python + PyGame + Flask + MySQL",
    //     description: "Starving Snake! Get as many apples as you can, try to not eat yourself. What's your ranking on the leaderboard?",
    //     image: "./img/snake.jpg",
    //     link: "https://github.com/QI-D/SnakeGame",
    //     l1: "Difficult Levels",
    //     l2: "Speed based on level",
    //     l3: "Score per apple based on level",
    //     l4: "Store player and game info in database",
    //     l5: "Web-based Leaderboard",
    // },
    // {
    //     title: "Maze Game",
    //     subtitle: "Python + PyGame + Flask",
    //     description: "A hero will not get stopped by a maze! Gear up, collecte the treasure and head to the next challenge.",
    //     image: "./img/maze_game.jpg",
    //     link: "https://github.com/QI-D/Maze_Game",
    //     l1: "MVC Architecture",
    //     l2: "Time & Item Restriction",
    //     l3: "Score Counting",
    //     l4: "Test-Driven Development",
    //     l5: "Agile Methodology",
    // }
]


// WEBPACK FOOTER //
// ./src/project-data.js